import Vue from "vue";
import VueRouter, { RouteConfig, Route } from "vue-router";
import { notFound } from "@/model/router/notFound.ts";

const redirectTo = process.env.VUE_APP_SITE_URL;

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/new",
    name: "New",
    component: () => import("../views/New.vue"),
    props(route: Route) {
      return {
        frontSideDesignNo: +route.params.frontSideDesignNo,
        currentStep: route.meta.step
      };
    },
    children: [
      {
        path: "input/:frontSideDesignNo?",
        name: "NewInput",
        component: () => import("../views/new/MInput.vue"),
        meta: { step: "input" }
      },
      {
        path: "confirm",
        name: "NewConfirm",
        component: () => import("../views/new/MConfirm.vue"),
        meta: { step: "confirm" }
      },
      {
        path: "thanks",
        name: "NewThanks",
        component: () => import("../views/new/MThanks.vue"),
        meta: { step: "thanks" }
      },
      notFound
    ]
  },
  {
    path: "/repeat",
    name: "Repeat",
    component: () => import("../views/Repeat.vue"),
    props(route: Route) {
      return {
        currentStep: route.meta.step
      };
    },
    children: [
      {
        path: "input",
        name: "RepeatInput",
        component: () => import("../views/repeat/MInput.vue"),
        meta: { step: "input" }
      },
      {
        path: "confirm",
        name: "RepeatConfirm",
        component: () => import("../views/repeat/MConfirm.vue"),
        meta: { step: "confirm" }
      },
      {
        path: "thanks",
        name: "RepeatThanks",
        component: () => import("../views/repeat/MThanks.vue"),
        meta: { step: "thanks" }
      },
      notFound
    ]
  },
  {
    path: "/manuscript",
    name: "Manuscript",
    component: () => import("../views/Manuscript.vue"),
    props(route: Route) {
      return {
        currentStep: route.meta.step
      };
    },
    children: [
      {
        path: "input",
        name: "ManuscriptInput",
        component: () => import("../views/manuscript/MInput.vue"),
        meta: { step: "input" }
      },
      {
        path: "confirm",
        name: "ManuscriptConfirm,",
        component: () => import("../views/manuscript/MConfirm.vue"),
        meta: { step: "confirm" }
      },
      {
        path: "thanks",
        name: "ManuscriptThanks",
        component: () => import("../views/manuscript/MThanks.vue"),
        meta: { step: "thanks" }
      },
      notFound
    ]
  },
  {
    path: "/inquiry",
    name: "Inquiry",
    component: () => import("../views/Inquiry.vue"),
    props(route: Route) {
      return {
        currentStep: route.meta.step
      };
    },
    children: [
      {
        path: "input",
        name: "InquiryInput",
        component: () => import("../views/inquiry/MInput.vue"),
        meta: { step: "input" }
      },
      {
        path: "confirm",
        name: "InquiryConfirm",
        component: () => import("../views/inquiry/MConfirm.vue"),
        meta: { step: "confirm" }
      },
      {
        path: "thanks",
        name: "InquiryThanks",
        component: () => import("../views/inquiry/MThanks.vue"),
        meta: { step: "thanks" }
      },
      notFound
    ]
  },
  {
    path: "*",
    beforeEnter: () => {
      location.href = redirectTo;
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

export default router;
